// Link de acesso que aponta para o NOSSO dominio (token_hash), e nao para o do Supabase.
//
// POR QUE EXISTE (08/10). O Resend avisou: "Ensure link URLs match sending domain -- Mismatched URLs can trigger spam filters". O link do
// e-mail era `https://<projeto>.supabase.co/auth/v1/verify?...`, enquanto o remetente e `pdled.com.br`; e o link mágico levou ~60 s para chegar
// numa caixa @pdled.com.br (servidor de hospedagem compartilhada). O dominio proprio do Auth e um complemento PAGO do Supabase, entao o e-mail passa a
// levar para o site, e o app confirma o login com `verifyOtp`. Padrao da documentacao do Supabase (auth-email-templates):
//   <a href="https://crm.pdled.com.br/?token_hash={{ .TokenHash }}&type=email">
// e a mesma pagina traz o outro cuidado que ela recomenda: "Certain email providers may have spam detection or other security features that
// prefetch URL links from incoming emails" e consomem o link de uso unico. Por isso a tela PEDE UM CLIQUE e so ai consome o token.
//
// Este arquivo e puro (sem rede, sem Supabase): le o endereco e o limpa.

// `email` e o tipo atual; `magiclink` e o nome antigo do mesmo link (medido no Auth local em 08/10: os dois confirmam o mesmo token).
const TIPOS_ACEITOS = new Set(['email', 'magiclink']);
// hash hexadecimal que o Auth gera (56 caracteres); a faixa larga evita amarrar o app ao comprimento de hoje.
const FORMATO_DO_HASH = /^[A-Za-z0-9_-]{20,200}$/;

/** `window.location.search` -> { tokenHash, tipo } ou null. Qualquer coisa fora do formato e ignorada, nunca repassada ao servidor. */
export function lerLinkDeAcesso(search) {
  const params = new URLSearchParams(String(search || '').replace(/^\?/, ''));
  const tokenHash = params.get('token_hash');
  const tipo = params.get('type');
  if (!tokenHash || !TIPOS_ACEITOS.has(tipo) || !FORMATO_DO_HASH.test(tokenHash)) return null;
  return { tokenHash, tipo };
}

/**
 * O mesmo endereco SEM `token_hash` e `type` (o resto da consulta e o `#` ficam). O token e de uso unico e nao deve ficar no historico,
 * no "voltar" do navegador, nem ser copiado junto com o endereco da tela.
 */
export function enderecoSemOLink(href) {
  const url = new URL(href);
  url.searchParams.delete('token_hash');
  url.searchParams.delete('type');
  return `${url.pathname}${url.search}${url.hash}`;
}
